import { styled } from "@mui/material/styles";

const Constant = {  // also allow virginie.user1@zoomappsec.us, jhomar.baluca.dev@gmail.com account to use Zoom Marketplace Development credentials
  homeURL: "https://www.treffas.com",
  zoomUserId: [36, 205],
  eventColor: [
    "#ff4f00",
    "#ff758e",
    "#e55cff",
    "#8247f5",
    "#0099ff",
    "#0ae8f0",
    "#17e885",
    "#ccf000",
    "#f8e436",
    "#ffa600",
  ],

  quillToolbar: {
    toolbar: [
      "italic",
      "bold",
      "underline",
      "strike",
      "link",
      "align", // left
      { align: "center" },
      { align: "right" },
      { list: "bullet" },
      "clean",
    ],
  },

  renderEventColor: styled("div")`
    ${({ bgcolor }) => `
        background-color: ${bgcolor};
    `}
    width: 46px;
    height: 46px;
    border-radius: 50%;
    outline: none;
    cursor: pointer;
    transition: 0.2s all;
    display: inline-block;
    margin-right: 8px;
    position: relative;

    &:last-child {
      margin-right: 0px;
    }

    > .MuiSvgIcon-root {
      position: absolute;
      top: 50%;
      left: 50%;
      color: white;
      font-size: 23px;
      transform: translate(-49%, -54%);
    }
  `,

  bannerColor: [
    "#ffffff",
    "#FCF4F4",
    "#FFF5EB",
    "#FFFDE7",
    "#F6FFF4",
    "#F2FBFC",
    "#F1F1FF",
    "#F5F2EE",
    "#FFC9C9",
    "#D0AEAE",
    "#F4CCA7",
    "#FFF6B0",
    "#C5FFBB",
    "#BDF4FD",
  ],

  interval: 15, // default appointment interval/gap

  dataCenterLocation: [
    { label: "Asia", value: "Asia" },
    { label: "Europe", value: "Europe" },
    { label: "Australia/New Zealand", value: "Australia/New Zealand" },
    // { label: "Oceania", value: "Oceania" },
    { label: "USA/Canada", value: "USA/Canada" },
  ],

  typeOfCoaching: [
    "Beauty and Personal Care",
    "Fitness and Sports",
    "Legal",
    "Food and Cooking",
    "People and Pets",
    "Lifestyle and Leisure",
    "Education",
    "IT and Web",
    "Healthcare",
    "Coaching and Consulting",
    "Business and Marketing",
    "Finance and Money",
    "Construction and Home",
    "Arts and Entertainment",
    "Others",
  ],

  // if you update the list of currency include the list in utils service in backend
  currency: [
    { label: "USD", value: "USD", symbols: "$" },
    { label: "EUR", value: "EUR", symbols: "€" },
    { label: "GBP", value: "GBP", symbols: "£" },
    { label: "AUD", value: "AUD", symbols: "$" },
    { label: "NZD", value: "NZD", symbols: "$" },
    { label: "CHF", value: "CHF", symbols: "Fr" },
  ],

  getCurrency: (currency) => {
    return Constant.currency.find((curr) => curr.value === currency);
  },

  checkQuestionType: (type) => {
    switch (type) {
      case "question-one-answer":
        return 1;
      case "question-multiple-answer":
        return 2;
      case "question-comment-essay":
        return 3;
      case "question-true-false":
        return 4;
      case "question-short-answer":
        return 5;
      default:
        return 6; // question-yes-no
    }
  },

  decodeQuestionType: (type) => {
    switch (type) {
      case 1:
        return "Multiple Choice (Single)";
      case 2:
        return "Multiple Choice (Multiple)";
      case 3:
        return "Essay";
      case 4:
        return "True/False";
      case 5:
        return "Short Answer";
      default:
        return "Yes/No"; // question-yes-no
    }
  },

  imageUrl: (path, filename) => {
    return `${process.env.REACT_APP_API}/${path}/${filename}`;
  },

  getFile: (path, filename) => {
    return `${process.env.REACT_APP_API}/api/get-files/${path}/${filename}`;
  },

  getFileInStorage: (path, filename) => {
    return `${process.env.REACT_APP_API}/storage/${path}/${filename}`;
  },

  paymentTerms: [
    { label: "7 days", value: "7 days" },
    { label: "15 days", value: "15 days" },
    { label: "30 days", value: "30 days" },
    { label: "45 days", value: "45 days" },
  ],

  automatedEmailNotificationStatus: {
    created_booking: "unsent",
    confirmed_booking: "unsent",
    reschedule_booking: "unsent",
    canceled_booking: "unsent",
    start_booking: "unsent",
    end_booking: "unsent",
    next_booking: "unsent",
  },

  availableFonts: [
    { label: "Grenette Pro", value: "grenettepro" },
    { label: "Alegreya Sans", value: "alegreya_sans" },
    { label: "Alegreya", value: "alegreya" },
    { label: "Archivo Narrow", value: "archivo_narrow" },
    { label: "Archivo", value: "archivo" },
    { label: "BioRhyme", value: "biorhyme" },
    { label: "Cardo", value: "cardo" },
    { label: "Cormorant", value: "cormorant" },
    { label: "Eczar", value: "eczar" },
    { label: "Fira Sans", value: "fira_sans" },
    { label: "Fraunces", value: "fraunces" },
    { label: "Karla", value: "karla" },
    { label: "Lato", value: "lato" },
    { label: "Libre Baskerville", value: "libre_baskerville" },
    { label: "Libre Franklin", value: "libre_franklin" },
    { label: "Lora", value: "lora" },
    { label: "Manrope", value: "manrope" },
    { label: "Merriweather", value: "merriweather" },
    { label: "Nanum Myeongjo", value: "nanum" },
    { label: "Neuton", value: "neuton" },
    { label: "Open Sans", value: "open_sans" },
    { label: "Poppins", value: "poppins" },
    { label: "PT Sans", value: "pt_sans" },
    { label: "Raleway", value: "raleway" },
    { label: "Roboto", value: "roboto" },
    { label: "Source Sans 3", value: "source_sans_3" },
    { label: "Source Serif 4", value: "source_serif_4" },
    { label: "Space Mono", value: "space_mono" },
    { label: "Spectral", value: "spectral" },
    { label: "Work Sans", value: "work_sans" },
  ],

  taskStatus: [
    {
      label: "Not Started",
      value: "not_started",
      bgColor: "#f3e8ff",
      textColor: "#6f21db",
    },
    {
      label: "In Progress",
      value: "in_progress",
      bgColor: "#dbeafe",
      textColor: "#2563EB",
    },
    {
      label: "Completed",
      value: "completed",
      bgColor: "#d1fae5",
      textColor: "#10B981",
    },
    {
      label: "Over Due",
      value: "over_due",
      bgColor: "#fee2e2",
      textColor: "#EC5B5B",
    },
  ],

  getTaskStatus: (currentstatus) => {
    return Constant.taskStatus.find((status) => status.value === currentstatus);
  },

  stripeIntegrationId: 3,

  AI_TONES: [
    "Professional",
    "Casual",
    "Friendly",
    "Educational",
    "Technical",
    "Creative",
  ],
};

export default Constant;
